import {intlShape, ProgressTick, SubmitButton, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl';

import styles from './SaveDeleteButtons.less';

export const I18N = defineMessages({
  RELOAD: {
    id: 'autoLayout.invalid.button',
    defaultMessage: 'Reload',
    description: 'text for auto layout reload button',
  },
});

const ReloadButton = ({className, intl, isLoading, onReload}) => (
  <SubmitButton
    className={classNames(className, 'btn-danger')}
    dataName={'reloadButton'}
    isPrimary={false}
    isDanger
    onClick={onReload}
    title={utils.TranslateUtils.translate(I18N.RELOAD, intl)}
  >
    <ProgressTick progressCounter={+isLoading}>
      <i className={classNames(styles.dlButtonIcon, 'fas fa-sync-alt fa-fw')} />
      <span className={styles.dlBoldText}>
        <FormattedMessage {...I18N.RELOAD} />
      </span>
    </ProgressTick>
  </SubmitButton>
);

ReloadButton.displayName = 'ReloadButton';

ReloadButton.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.any),
  ]),
  onReload: PropTypes.func,
  intl: intlShape.isRequired,
  isLoading: PropTypes.bool,
};

ReloadButton.defaultProps = {
  className: '',
  onReload: undefined,
  isLoading: false,
};

export default injectIntl(ReloadButton);
